<dashboardnav>
  <cradua-category
  [categorys]="categorys$ | async"
  (category)="onSubmitCategory($event)"
  (deleteCategoryEvent)="onDeleteCategory($event)"
  *ngIf="(isLoadingCategory$ | async ) === false"
  >
</cradua-category>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingCategory$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
